import { useState } from "react";
import { TbChevronDown } from "react-icons/tb";
import { CarePlusDosageOption } from "../../ChooseTreatmentCarePlus/types";
import { packLabel } from "../helpers";
import PriceValue from "./PriceValue";

const DoseDropdown = ({
  dosages,
  selectedId,
  onSelect,
  t,
}: {
  dosages: CarePlusDosageOption[];
  selectedId: number | null;
  onSelect: (productItemId: number) => void;
  t: (key: string, fallback: string) => string;
}) => {
  const [open, setOpen] = useState(false);
  const selected = dosages.find((d) => d.product_item_id === selectedId) ?? dosages[0] ?? null;
  const hasChoice = dosages.length > 1;
  if (!selected) return null;

  return (
    <div className="relative w-full">
      <button
        id="wl3_treatment_dose_dropdown"
        type="button"
        onClick={() => hasChoice && setOpen((o) => !o)}
        className="flex cursor-pointer h-[60px] w-full items-center justify-between rounded-[12px] border border-solid border-[#dee3ea] bg-white px-[16px] text-left"
      >
        <div className="flex min-w-0 flex-col gap-[4px]">
          <p className="text-[10px] text-[#616975]">{t("your_dosage", "your dosage")}</p>
          <div className="flex min-w-0 items-baseline gap-[10px]">
            <span className="shrink-0 text-[16px] font-medium text-[#08080a] max-[389px]:text-[14px]">
              {selected.dosage_str}
            </span>
            {packLabel(selected) && (
              <span className="min-w-0 truncate text-[16px] text-[#99a3b2] max-[389px]:text-[14px]">
                {packLabel(selected)}
              </span>
            )}
          </div>
        </div>
        {hasChoice && (
          <TbChevronDown size={24} className={`shrink-0 text-[#616975] transition-transform duration-200 ${open ? "[transform:rotate(180deg)]" : ""}`} />
        )}
      </button>
      {hasChoice && open && (
        <div
          className="absolute z-10 mt-2 w-full animate-fade-in-up-10 overflow-hidden rounded-[12px] border border-[#eef1f6] bg-white shadow-[0px_3px_8px_0px_rgba(8,8,10,0.1)]"
          style={{ animationDuration: "200ms" }}
        >
          {dosages.map((d) => (
            <button
              key={d.product_item_id}
              id={`wl3_treatment_dose_${d.product_item_id}`}
              type="button"
              onClick={() => {
                onSelect(d.product_item_id);
                setOpen(false);
              }}
              className="flex cursor-pointer w-full items-center justify-between gap-[8px] border-0 bg-white px-[16px] py-[12px] text-left hover:bg-[#f8f8f8]"
            >
              <span className="min-w-0 truncate text-[16px] text-[#08080a] max-[389px]:text-[14px]">
                {d.dosage_str} {packLabel(d) && <span className="text-[#99a3b2]">{packLabel(d)}</span>}
              </span>
              <PriceValue value={d.price} className="shrink-0 text-[16px] font-medium text-[#e88103] max-[389px]:text-[14px]" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default DoseDropdown;
